/**
 * Widget 配置验证器
 */

import { WidgetConfig } from './widget.types';
import { DEFAULT_CONFIG } from './default.config';

/**
 * 验证并规范化配置
 */
export function validateConfig(config: Partial<WidgetConfig>): WidgetConfig {
  const validated: WidgetConfig = {
    ...DEFAULT_CONFIG,
    ...config
  };

  // 验证颜色格式
  if (validated.themeColor && !/^#[0-9A-F]{6}$/i.test(validated.themeColor)) {
    console.warn('[SmartCS] 无效的主题颜色，使用默认值');
    validated.themeColor = DEFAULT_CONFIG.themeColor;
  }

  // 验证尺寸
  if (validated.width && (validated.width < 300 || validated.width > 600)) {
    console.warn('[SmartCS] 宽度应在 300-600px 之间');
    validated.width = DEFAULT_CONFIG.width;
  }

  if (validated.height && (validated.height < 400 || validated.height > 800)) {
    console.warn('[SmartCS] 高度应在 400-800px 之间');
    validated.height = DEFAULT_CONFIG.height;
  }

  return validated;
}
